// defaultData.js

export const siteData = {
  business: {
    businessName: "Masala Cottage",
    contact: {
      contactNumber: "+1-678-712-5129",
      faxNumber: "+1-555-987-6543",
      email: 'contact@masalacottage.com',
      businessAddress: "931 Hwy 155 S, McDonough, GA 30253",
      googleMapsLocation: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6661.106790182144!2d-84.16694208924561!3d33.40881395132102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f45ba5cda431a3%3A0x961f9528eba73a3c!2sMasala%20Cottage!5e0!3m2!1sen!2sus!4v1740606801833!5m2!1sen!2sus", // Your Google Maps embed URL
      businessHours: [
        "Monday-Saturday: 11:30 AM - 8:30 PM",
        "Saturday: Closed",
      ],
    },
    socialMedia:{
      facebook:{
        enable: true,
        url: "https://www.facebook.com/masalacottagega/"
      },
      instagram:{
        enable: true,
        url: "https://www.instagram.com/masala_cottage/"
      },
      yelp:{
        enable: true,
        url: "https://www.yelp.com/biz/masala-cottage-mcdonough-3"
      },
      tripAdvisor:{
        enable: true,
        url: "https://www.tripadvisor.in/Restaurant_Review-g35102-d14070084-Reviews-Masala_Cottage-McDonough_Georgia.html"
      }
    },
  },
  about: {
    storyData: {
      title: "Our Story",
      imageUrl: "https://res.cloudinary.com/dczfqghqw/image/upload/v1740602331/8K9A7862_fs3vxa.jpg",
      paragraphs: [
        "Founded in 2018, Masala Cottage began with a simple vision: to bring the authentic flavors of Indian cuisine to our community. Our journey started with family recipes passed down through generations.",
        "What sets us apart is our unwavering commitment to quality and authenticity. Every dish we serve is crafted with carefully selected spices and ingredients, following traditional cooking methods that have stood the test of time.",
        "Today, we're proud to be more than just a restaurant - we're a place where memories are made, where traditions are honored, and where every meal tells a story of our rich cultural heritage."
      ]
    }
  },
  catering: {
    miniumDaysAdvance: 2,
    minimumPeople: 10
  },
  gallery: [
    {
      url: 'https://res.cloudinary.com/dczfqghqw/image/upload/v1740601899/8K9A7698_hwm7gm.jpg',
      title: 'Butter Chicken',
      category: 'Chicken Entrees'
    },
    {
      url: 'https://res.cloudinary.com/dczfqghqw/image/upload/v1740637593/8K9A7808_compressed_rlvkyv.jpg',
      title: 'Chicken 65',
      category: 'Non Vegeterian Appetizers'
    },
    {
      url: 'https://res.cloudinary.com/dczfqghqw/image/upload/v1740637663/Biryani_2024_compressed_ckafdm.jpg',
      title: 'Chicken Biryani',
      category: "Biryani's"
    },
    {
      url: 'https://res.cloudinary.com/dczfqghqw/image/upload/v1740637536/8K9A7762_compressed_pq5djz.jpg',
      title: 'Chilli Paneer',
      category: 'Vegeterian Appetizers'
    },
    {
      url: 'https://res.cloudinary.com/dczfqghqw/image/upload/v1740637579/8K9A7796_compressed_wm19ld.jpg',
      title: 'Masala Wings',
      category: 'Non Vegeterian Appetizers'
    },
    {
      url: 'https://res.cloudinary.com/dczfqghqw/image/upload/v1740637499/8K9A7733_compressed_vlb3qn.jpg',
      title: 'Dal Fry',
      category: 'Vegeterian Entrees'
    }
  ],
  hero: {
    backgroundType: "image", // or "color" or // "image"
    backgroundImage: "https://res.cloudinary.com/dczfqghqw/image/upload/v1740637641/8K9A7846_compressed_keohis.jpg", // Path to your image
    backgroundColor: "bg-gradient-to-r from-primary/10 to-secondary/10", // Tailwind class for color
    tagline: "Local True Indian Cuisine",
    title: "Experience Authentic Indian Cuisine",
    description: "Discover the rich flavors and traditions of India at Masala Cottage. Every dish tells a story of heritage and passion.",
    buttonLabel: "View Menu & Order Now",
  },
  reviews: [
    {
        name: "Adriana Patricia Insuasti Coral",
        rating: 5,
        comment: "First time in Cottage restaurant and we were impressed with the food! 10/10 the butter chicken is a must to try! The gentleman was kind and give us a garlic bread 🥖 for free for the first visit! We will comeback soon!",
        image: "https://randomuser.me/api/portraits/men/4.jpg",
        date: "Februray 2025"
      },
    {
      name: "Gordon Wery",
      rating: 5,
      comment: "Great food, a bit far from the city, but worth the trip. Very down to earth, homestyle vibe, and reasonably priced. Not your average Indian spot, as they have a unique approach to every dish. I hope they will open a location in Atlanta proper.",
      image: "https://randomuser.me/api/portraits/women/1.jpg",
      date: "December 2024"
    },
    {
      name: "Goddess Shannon",
      rating: 5,
      comment: "I really wish y'all could smell this and the flavor; I almost feel like I took a flight. I am most definitely pleased with my decision to try something different. I love spicy food, so I was happy that I could choose my own heat. The chicken masala and naan are delicious, and I have a little left over for my late night munchies 🥰🥰🥰",
      image: "https://randomuser.me/api/portraits/men/2.jpg",
      date: "November 2023"
    },
    {
      name: "Prateek Singh",
      rating: 5,
      comment: "One of the best indian food restaurants in non-metro cities. We were searching for a good Indian place in or around griffin and found this. Drove 20 miles with a hope and food made it worth.Appetizers, main course and dessert everything was delicious with considerable quantity.Would surely recommend this place.",
      image: "https://randomuser.me/api/portraits/women/3.jpg",
      date: "October 2023"
    },
    
  ],
  stats: [
    {
      number: 7,
      label: 'Years of Experience',
      suffix: '+',
    },
    {
      number: 50000,
      label: 'Happy Customers',
      suffix: '+',
    },
    {
      number: 100,
      label: 'Dishes on Menu',
      suffix: '+',
    },
    {
      number: 4.5,
      label: 'Average Rating',
      suffix: '/5',
      decimals: 1,
    },
  ]
}

export const allData = {
    business: siteData.business,
    about: siteData.about,
    catering: siteData.catering,
    gallery: siteData.gallery,
    hero: siteData.hero,
    reviews: siteData.reviews,
    stats: siteData.stats
};
  